__turbopack_context__.v({
  "frame": "tap-mount-module__fB8PTq__frame",
  "pad": "tap-mount-module__fB8PTq__pad",
});
